import {connect} from 'react-redux';
import TabFirm from './TabFirm';
import {getStep9Grid} from '../../actions/steps/getStep9Grid';
import {setStep9Page} from '../../actions/steps/setStep9Page';
import {getStep9GridForExcel} from '../../actions/steps/getStep9GridForExcel';
import {saveFirmRow} from '../../actions/steps/step9SaveRow';
import {showLittlePopup} from '../../actions/step9LittlePopup';
import {actions as A} from '../../constants/actions';
import {api} from '../../constants/api';
import {saveTab2Filters} from '../../actions/step9SaveTabFilters';

const mapStateToProps = ({
                           step9Firm: {list, page, totalPages, totalResultCount, loading},
                           step9FirmForExcel: {listForExcel},
                           step9Filters: {tab2}
                         }) => ({
  listForExcel,
  list,
  page,
  totalPages,
  totalResultCount,
  previousFilters: tab2,
  loading
});

export default connect(
  mapStateToProps,
  {
    getStep9GridFirm: getStep9Grid({
      actions: {
        pending: A.GET_STEP_9_GIRD_FIRM_DATA,
        success: A.GET_STEP_9_GIRD_FIRM_DATA_SUCCESS,
        failure: A.GET_STEP_9_GIRD_FIRM_DATA_FAILURE,
        setPage: A.SET_STEP_9_GIRD_FIRM_DATA_PAGE,
      },
      api: api.GET_STEP_9_GIRD_FIRM_DATA,
    }),
    setStep9FirmPage: setStep9Page(A.SET_STEP_9_GIRD_FIRM_DATA_PAGE),
    getStep9GridFirmForExcel: getStep9GridForExcel({
      actions: {
        pending: A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL,
        success: A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_SUCCESS,
        failure: A.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL_FAILURE,
      },
      api: api.GET_STEP_9_GRID_FIRM_DATA_FOR_EXCEL,
    }),
    saveRow: saveFirmRow,
    saveFilters: saveTab2Filters,
    showLittlePopup,
  }
)(TabFirm);
